import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { Bookmark } from '@/domain/value_objects/bookmark/bookmark'
import { BookmarkModuleName } from '@/store/modules/modules'

export class BookmarkViewModel {
  private store = useStore()

  bookmark: ComputedRef<Bookmark> = computed(() => this.store.getters[`${BookmarkModuleName}/bookmark`])
  isLoading: ComputedRef<boolean> = computed(() => this.store.getters[`${BookmarkModuleName}/isLoading`])
  error: ComputedRef<string | null> = computed(() => this.store.getters[`${BookmarkModuleName}/error`])

  async getBookmark(userId: string): Promise<void> {
    this.store.dispatch(`${BookmarkModuleName}/getBookmark`, { userId })
  }

  async postBookmark(problemId: string, userId: string): Promise<void> {
    this.store.dispatch(`${BookmarkModuleName}/postBookmark`, { problemId, userId })
  }

  async deleteBookmark(problemId: string, userId: string): Promise<void> {
    this.store.dispatch(`${BookmarkModuleName}/deleteBookmark`, { problemId, userId })
  }
}
